import React from 'react';
import PropTypes from 'prop-types';
import './PrescriptionForm.css';

const PrescriptionForm = ({ prescription, onSendPrescription }) => {
  return (
    <div className="prescription-form">
      <h3 id="prescription-form-heading">Prescrição Médica</h3>
      <textarea
        value={prescription}
        onChange={(e) => onSendPrescription(e.target.value)}
        placeholder="Escreva a prescrição médica aqui..."
        aria-labelledby="prescription-form-heading"
      />
      <button
        onClick={onSendPrescription}
        aria-label="Enviar prescrição ao paciente"
      >
        Enviar Prescrição
      </button>
    </div>
  );
};

PrescriptionForm.propTypes = {
  prescription: PropTypes.string.isRequired,
  onSendPrescription: PropTypes.func.isRequired,
};

export default PrescriptionForm;
